import axios from "axios";
import { host } from "./base.api.js";

// 是否需要验证码
export const getIsNeedCodeReq = ({ mobile, pvAreaId }) => {
  return axios({
    method: "post",
    url: "//autoapi.autohome.com.cn/fc-autoloan-api/decisionVerifyCode/codeDecision",
    params: {
      mobile,
      eid: pvAreaId,
      useLocalUserPhone: 0,
      cityId: 110100,
    },
  });
};

// 获取验证码
export const getCaptchaReq = ({ mobile, gvCode }) => {
  return axios({
    method: "post",
    url: "//autoapi.autohome.com.cn/fc-autoloan-api/decisionVerifyCode/sendByMobile",
    params: {
      mobile,
      gvCode: gvCode,
    },
  });
};

// 获取图形验证码
export const getImageCaptchaReq = ({ mobile }) => {
  return axios({
    method: "post",
    url: "//autoapi.autohome.com.cn/fc-autoloan-api/decisionVerifyCode/sendGvCodeByMobile",
    params: {
      mobile,
    },
  });
};

// 回收验证码
export const recycleCaptchaReq = ({ mobile, verifyCode }) => {
  return axios({
    method: "post",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    url: "//autoapi.autohome.com.cn/fc-autoloan-api/decisionVerifyCode/validateByMobile",
    params: {
      mobile,
      authCode: verifyCode,
    },
  });
};

/*
 * 获取跳转链接
 * @param {*} Type 跳转类型 1 按钮跳转 2 banner跳转
 * @param {*} PlatformParam 加密参数
 * @param {int} ActivityId 活动id
 * @param {*} PhoneNumber 手机号
 * @param {*} UserName 购车人
 * @param {*} PvAreaId pvid
 * @returns 跳转链接

}
*/
export const getJumpUrlReq = ({
  Type,
  PlatformParam,
  ActivityId,
  PhoneNumber,
  UserName,
  PvAreaId,
  SpecId = "",
}) => {
  return axios({
    method: "post",
    url: host + "/api/socialagent/order/GetJumpUrl",
    data: {
      Type,
      PlatformParam,
      ActivityId,
      PhoneNumber,
      UserName,
      PvAreaId,
      SpecId,
    },
  });
};

// 更新保险状态
export const updateInsuranceStatusReq = ({
  platformOrderId,
  ActivityId,
  MessageCode,
}) => {
  return axios({
    method: "post",
    url: host + "/api/socialagent/order/PutInsuranceStatus",
    data: {
      platformOrderId,
      ActivityId,
      MessageCode,
    },
  });
};

// 获取场景订单
export const getSceneOrderListReq = ({
  beginTime,
  endTime,
  businesslineIds,
  orderNodeIds,
  customerLabelIds,
  matchingFields,
  dataType,
  businessType,
  checkType,
  pageSize = 10,
  pageIndex = 1,
}) => {
  return axios({
    method: "post",
    url: host + "/api/socialagent/order/sceneList",
    data: {
      beginTime,
      endTime,
      businesslineIds,
      orderNodeIds,
      customerLabelIds,
      matchingFields,
      dataType,
      businessType,
      checkType,
      pageSize,
      pageIndex,
      t: new Date().getTime(),
    },
  });
};

// 获取资源位
export const getResourceReq = ({ locationId }) => {
  return axios({
    method: "get",
    url:
      host +
      "//j.jiajiabaoxian.com.cn/insurance/location/getAvailableResourceLinkNew",
    params: {
      businessType: 1,
      locationId,
      cityName: "北京市",
      fetchNum: 5,
      terminalType: 1,
    },
  });
};
// 获取车系信息接口
export const getCarSeriesInfoReq = ({
  type = "",
  MediaId = "",
  PlatformParam = "",
}) => {
  return axios({
    method: "post",
    url: host + "/api/socialagent/order/IsShowSpce",
    data: {
      Type: type,
      MediaId: MediaId,
      PlatformParam: PlatformParam,
      t: new Date().getTime(),
    },
  });
};



// WEBPACK FOOTER //
// ./src/api/swap.js